// src/services/payment.service.js
import api from './api';

const paymentService = {

  // Add payment entry (submit for review)
  addPayment: async (paymentData) => {
    try {
      const response = await api.post('/payments', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error adding payment:', error);
      throw error;
    }
  },

  // Keep createPayment as alias for addPayment
  createPayment: async (paymentData) => {
    try {
      const response = await api.post('/payments', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  },

  // Get all payments with status filter
 getPayments: async (page = 1, limit = 20, search = '', status = '', companyId = null) => {
  try {
    const params = { page, limit };
    if (search) params.search = search;
    if (status) params.status = status;
    if (companyId) params.companyId = companyId;
    const response = await api.get('/payments', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching payments:', error);
    throw error;
  }
},


  getPaymentByOrder: async (orderId) => {
    try {
      const response = await api.get(`/payments/order/${orderId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment by order:', error);
      throw error;
    }
  },

  
getPaymentsByDealer: async (companyId = null) => {
  try {
    const params = {};
    if (companyId) params.companyId = companyId;
    const response = await api.get('/payments/by-dealer', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching dealer payments:', error);
    throw error;
  }
},

getPaymentsByDealerId: async (dealerId, status = 'ALL', companyId = null) => {
  try {
    const params = {};
    if (status && status !== 'ALL') params.status = status;
    if (companyId) params.companyId = companyId;
    const response = await api.get(`/payments/dealer/${dealerId}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching dealer payments:', error);
    throw error;
  }
},

  confirmPayment: async (id) => {
    try {
      const response = await api.post(`/payments/${id}/confirm`);
      return response.data;
    } catch (error) {
      console.error('Error confirming payment:', error);
      throw error;
    }
  },

  rejectPayment: async (id, note = '') => {
    try {
      const response = await api.post(`/payments/${id}/reject`, { note });
      return response.data;
    } catch (error) {
      console.error('Error rejecting payment:', error);
      throw error;
    }
  },

};

export default paymentService;